import React, { useRef, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { errMsg } from "@/components/email/EmParts";
import { Inventory, Ownership } from "@/components/email/ReachParts";

const PERIODS = [["12m", "12 months"], ["24m", "24 months"], ["5y", "5 years"], ["all", "All time"]];

export function ReachReport() {
  const [d, setD] = useState(null);
  const [period, setPeriod] = useState("12m");
  const [busy, setBusy] = useState(false);
  const seq = useRef(0);
  const run = async (p = period) => {
    const me = ++seq.current;
    setBusy(true);
    try { const r = await api.get("/email-marketing/automations/reach", { params: { period: p } }); if (me === seq.current) { setD(r.data); } } catch (e) { toast.error(errMsg(e)); } finally { if (me === seq.current) { setBusy(false); } }
  };
  const pick = (p) => { setPeriod(p); if (d) { run(p); } };
  return (
    <section className="bg-white border border-slate-200 rounded-2xl p-5 space-y-4" data-testid="auto-reach">
      <div className="flex flex-wrap items-center gap-2">
        <div className="mr-auto"><h2 className="text-base font-bold text-slate-900">Reach report</h2>
          <p className="text-sm text-slate-500">Customers each ready automation would reach in the chosen period. Read-only — nothing is scheduled or sent.</p></div>
        <div className="flex rounded-lg border border-slate-200 overflow-hidden" data-testid="auto-reach-periods">
          {PERIODS.map(([k, l]) => <button key={k} type="button" onClick={() => pick(k)} className={`px-3 h-8 text-xs font-medium ${period === k ? "bg-slate-900 text-white" : "bg-white text-slate-600 hover:bg-slate-50"}`} data-testid={`auto-reach-period-${k}`}>{l}</button>)}
        </div>
        <Button size="sm" variant="outline" onClick={() => run()} disabled={busy} data-testid="auto-reach-run">{busy ? "Counting…" : d ? "Recount" : "Count reach"}</Button>
      </div>
      {d && <div className="overflow-x-auto"><table className="w-full min-w-[640px] text-sm" data-testid="auto-reach-table"><thead><tr className="text-left text-xs text-slate-500">
        <th className="pb-2 font-medium">Automation</th><th className="pb-2 font-medium">Type</th><th className="pb-2 font-medium">Matching customers</th><th className="pb-2 font-medium">Could receive</th><th className="pb-2 font-medium">Main reason others can't</th></tr></thead>
        <tbody>{d.items.map((r) => (
          <tr key={r.id} className="border-t border-slate-100" data-testid={`auto-reach-row-${r.id}`}>
            <td className="py-2 pr-3">{r.name}{!r.has_data && <span className="ml-2 text-[11px] text-amber-700">needs product links / intervals</span>}</td>
            <td className="py-2 pr-3 text-slate-500">{r.message_class === "service" ? "Service" : "Marketing"}</td>
            <td className="py-2 pr-3">{r.total}</td><td className="py-2 pr-3 font-semibold">{r.eligible}</td>
            <td className="py-2 pr-3 text-xs text-slate-500">{r.top_block || "—"}</td></tr>))}</tbody></table>
        <p className="text-xs text-slate-400 mt-2" data-testid="auto-reach-meta">{PERIODS.find(([k]) => k === d.period)?.[1]} · counted {new Date(d.generated_at).toLocaleString("en-GB")}. All automations remain off.</p>
        <div className="mt-4 grid gap-2 sm:grid-cols-2 lg:grid-cols-3 text-sm" data-testid="auto-reach-sources">
          {Object.entries(d.data_sources || {}).map(([k, v]) => <div key={k} className="rounded-lg bg-slate-50 px-3 py-2 flex justify-between gap-2"><span className="text-slate-600">{k}</span><b>{v}</b></div>)}</div></div>}
      <Ownership />
      <Inventory />
    </section>
  );
}
